import type { ReactNode } from "react";
import "./ui.css";

interface SectionProps {
	title: string;
	level?: 2 | 3;
	actions?: ReactNode;
	children: ReactNode;
}

export function Section({ title, level = 3, actions, children }: SectionProps) {
	const Heading = level === 2 ? "h2" : "h3";
	return (
		<section className="ui-section">
			<div className="ui-section-head">
				<Heading className="ui-section-header-title">{title}</Heading>
				{actions && <div className="ui-section-header-actions">{actions}</div>}
			</div>
			<div className="ui-section-body">{children}</div>
		</section>
	);
}
